import React, { useEffect, useState } from 'react';
import { useBookingWizard } from 'core/contexts/bookingWizard';
import { useCurrency } from 'core/contexts/currency';
import { Box, Grid2, Typography } from '@mui/material';
import { AlertDialog, getUnitLabel, PriceDetails } from '@utriper/core-ui';
import ExperienceCard from './components/ExperienceCard';
import TriperCard from './components/TriperCard';
import Summary from '../SelectActivityForm/components/Summary';
import { Title } from '../../styles';

const BookingDetails = () => {
    const { checkoutItems, handleOpenEdit, handleOpenDelete, setActiveStep, handleOpenAlert } = useBookingWizard();
    const { currency } = useCurrency();
    const [openDetails, setOpenDetails] = useState(false);
    const [itemToView, setItemToView] = useState(null);
    const [bottomSpace, setBottomSpace] = useState(0);

    useEffect(() => {
        if (checkoutItems?.length <= 0) {
            handleOpenAlert(true);
            setActiveStep(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkoutItems]);

    const handleOpenPriceDetails = (itemData) => {
        setItemToView(itemData);
        setOpenDetails(true);
    };

    return (
        <Grid2 size={12} sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' } }}>
            {/* nowrap: a Grid2 container wraps by default, and stretched to the step's height a long list wrapped into a second column under the Summary. */}
            <Grid2 container direction="column" wrap="nowrap" size={{ xs: 12, md: 6 }} sx={{ pb: { xs: `${bottomSpace}px`, md: 2 } }}>
                <Title title="Datos de la reserva" description="Revisa que todo este correcto antes de continuar con el pago." />

                {/* Checkout Items */}
                <Box display="flex" flexDirection="column" gap={1.5} width="100%" maxWidth="640px">
                    <Typography variant="subtitle1" fontWeight={600} noWrap>
                        Actividades
                    </Typography>
                    {checkoutItems?.map(({ id, name, bundleName = null, formData, pricing, ...props }) => {
                        const { experienceDetailSelected, selectedSlot } = formData;
                        const { unitPricing } = pricing;

                        return (
                            <ExperienceCard
                                key={id}
                                title={`${name} ${bundleName ? `(${bundleName})` : ''}`}
                                option={experienceDetailSelected}
                                date={selectedSlot?.startUTC}
                                peopleLabel={getUnitLabel(unitPricing)}
                                total={pricing?.payTotal}
                                currency={currency}
                                onDelete={() => {
                                    handleOpenDelete({ id, name });
                                }}
                                onEdit={() => {
                                    handleOpenEdit({ id, name, bundleName, formData, pricing, ...props });
                                }}
                                onOpenDetails={() => {
                                    handleOpenPriceDetails({ id, name, bundleName, formData, pricing, ...props });
                                }}
                                {...props}
                            />
                        );
                    })}
                </Box>

                {/* Triper Info */}
                <Box mt={3} maxWidth="640px">
                    <Typography variant="subtitle1" fontWeight={600} noWrap>
                        Viajero
                    </Typography>

                    <TriperCard />
                </Box>
            </Grid2>

            <Grid2 container size={{ xs: 12, md: 6 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Summary setBottomSpace={setBottomSpace} hideHeader />
            </Grid2>

            <AlertDialog
                open={openDetails}
                handleClose={() => {
                    setOpenDetails(false);
                }}
                hideTitle
                hideSubmit
                dialogContent={<PriceDetails unitPricing={itemToView?.pricing?.unitPricing || []} currency={currency} totalPrice={itemToView?.pricing?.payTotal} experience={itemToView} date={new Date(itemToView?.selectedSlot?.startUTC)} />}
                labelBack={'Cerrar'}
                maxWidth="sm"
                fullWidth
            />
        </Grid2>
    );
};

export default BookingDetails;
